import { render } from "./DownloadApp.vue?vue&type=template&id=6a89b966"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"

import "./DownloadApp.vue?vue&type=style&index=0&id=6a89b966&lang=css"

import exportComponent from "/Users/ullas/Desktop/code/imeuswe-website-invite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__